import Controller, { inject as controller } from '@ember/controller';
import type MarketRevenueInsightController from 'lumen/controllers/market/revenue-insight';

export default class MarketRevenueInsightPortfolioDetailsModalController extends Controller {
  @controller('market.revenue-insight')
  declare multi: MarketRevenueInsightController;
}
